export const LANGUAGES = {
        BASQUE: 'eu',
        SPANISH: 'es',
        FRENCH: 'fr',
        ENGLISH: 'en',
};

export const getDataWithLanguage = (response, language) => {
        return Array.isArray(response) ?
                response.map(x=>getObjectWithLanguage(x,language)) :
                getObjectWithLanguage(response, language);
}

export const getObjectWithLanguage = (response, language) => {
        if(!response||!language) return;

        const keys = Object.keys(response)
                .filter(key => key.match('_' + language))
                .map(key=> key.replace(/_[a-z]{2}$/,''));
        
        const untranslated_response = Object.keys(response).reduce( (acc, key) =>({
                ...acc,
                ...key.match(/_[a-z]{2}$/)?{}:{
                        [key]:response[key]
                }
        }),{});
        
        const translated = keys.reduce((acc, key)=> {
                const prev = acc[key];
                const translated = response[key+'_'+language] || response[key+'_eu'];
                return (translated == null) ? acc : {
                        ...acc,
                        [key]:Array.isArray(prev)? prev.map(p=>({...p,id:p.id,language:language})).concat(translated) : translated,
                };
        }, untranslated_response);
        
        return translated;
}
